import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../lib/api";

export const WhatsAppFloat = () => (
    <a
        data-testid="whatsapp-float"
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with LUXATI on WhatsApp"
        title="Chat with LUXATI on WhatsApp — +91 78787 87141"
        className="fixed bottom-6 right-6 z-40 flex h-13 w-13 items-center justify-center rounded-full border border-ink/10 bg-ink p-3.5 text-ivory shadow-lg shadow-ink/20 transition-transform duration-500 hover:scale-105 hover:bg-charcoal"
    >
        <MessageCircle className="h-5 w-5" />
    </a>
);
